// from https://github.com/apollographql/apollo-link/issues/646#issuecomment-423279220

import { Observable } from '@apollo/client';

const promiseToObservable = <T extends unknown>(promise: Promise<T>) =>
  new Observable((subscriber) => {
    promise.then(
      (value) => {
        if (subscriber.closed) return;
        subscriber.next(value);
        subscriber.complete();
      },
      (err) => subscriber.error(err)
    );
  });

export default promiseToObservable;
